// extracted by mini-css-extract-plugin
export default {"page":"Q0-z","cartModal":"R0-z","checkout":"S0-z","placeholder":"T0-z","account":"U0-z"};